<template>
	<type-wrapper class="type-G" limit :bgUrl="showData.image">
		<type-grid row="2" margin>
			<type-title large left v-if="showData.title">{{ showData.title }}</type-title>
			<type-content large v-if="showData.content">{{ showData.content }}</type-content>
		</type-grid>
		<type-grid row="2" margin middle>
			<div class="type-G-leave-email">
				<input class="email-value" type="text" placeholder="Leave email" v-model="email">
				<type-button class="email-button" round size="16px" height="36px" @click="sendEmail">SEND</type-button>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 简版收email地址框
	import mixin from '../mixin.js'
	export default {
		name: 'type-G',
		mixins: [ mixin ],
		data() {
			return {
				email: ''
			}
		},
		methods: {
			sendEmail() {
				const data = {
					email: this.email
				};
				const result = this.$verify.verify(data);
				// console.log('数据', JSON.parse(JSON.stringify(data)), '验证', JSON.parse(JSON.stringify(result)))
				if (result.error.email) {
					this.$message(result.error.email);
				} else {
					const content = `email=${data.email}`;
					this.$http.user.report_bug(content).then(res => {
						if (res.status === 'success') {
							this.$message('提交成功');
							this.email = '';
						}
					});
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.type-G{
        .type-G-leave-email{
        	width: 100%;
        	height: 50px;
            overflow: hidden;
        	border-radius: 25px;
        	background-color: #FFFFFF;
        	box-shadow: inset 0 1px 1px rgba(0, 0, 0,  .075), 0 0 8px rgba(102, 175, 233, .6);
        	position: relative;
        	.email-value{
        		height: 36px;
        		color: #000000;
        		font-size: 16px;
        		line-height: 36px;
        		font-weight: linear;
        		width: calc(100% - 115px);
        		position: absolute;
        		top: 7px;
        		right: 97px;
        		border: none;
        		outline: none;
        		&:focus{
        			border: none;
        			outline: none;
        		}
        		&:-webkit-input-placeholder, &::-webkit-input-placeholder,
        		&:-ms-input-placeholder, &::-ms-input-placeholder,
        		&:-moz-placeholder, &::-moz-placeholder{
        			color: #FAFAFA;
        		}
        	}
        	.email-button{
        		background-color: #41466E;
        		position: absolute;
        		top: 7px;
        		right: 7px;
        	}
        }
    }
</style>
